import { type Common } from './common.js';
import type * as ProviderNoteSection from './models/providerNoteSection.js';
import { type StandardNoteSectionWithOverride } from './models/standardNoteSection.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(providerUserId: string): Promise<ProviderNoteSection.ProviderNoteSection[]> {
    const url = this.common.constructPath(`/provider-note-sections`, {
      providerUserId,
    });
    return await this.common.getJSON(url);
  }

  async findAllWithOverride(providerUserId: string): Promise<StandardNoteSectionWithOverride[]> {
    const url = this.common.constructPath(`/provider-note-sections`, {
      providerUserId,
      override: true,
    });
    return await this.common.getJSON(url);
  }

  async findOneById(id: string): Promise<ProviderNoteSection.ProviderNoteSection> {
    const url = this.common.constructPath(`/provider-note-sections/${id}`);
    return await this.common.getJSON(url);
  }

  async create(
    values: ProviderNoteSection.CreateValues
  ): Promise<ProviderNoteSection.ProviderNoteSection> {
    const url = this.common.constructPath(`/provider-note-sections`);
    return await this.common.postJSON(url, values);
  }

  async update(
    id: string,
    values: ProviderNoteSection.UpdateValues
  ): Promise<ProviderNoteSection.ProviderNoteSection> {
    const url = this.common.constructPath(`/provider-note-sections/${id}`);
    return await this.common.patchJSON(url, values);
  }

  async remove(id: string): Promise<{ success: true }> {
    const url = this.common.constructPath(`/provider-note-sections/${id}`);
    return await this.common.deleteJSON(url);
  }
}
